import { AppSettings } from "../constants";
import Jwt from "../helper/interceptors";
import { MapResponse } from "../helper/helper-api";

export const createCustomOrder = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put("/api/request-types", params.data)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getDefaultConfigs = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/request-for-services/GetDefaultConfigs`)
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const submitDefaultConfigs = (params) => {
  console.log('creste Default config', params.params)
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`/api/request-for-services/CreateDefaultConfigs`,params.params )
    .then((response) => {
      return MapResponse(response);
    })
    .catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const selectTrade = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/trades/trades-select-list`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};


// WEBPACK FOOTER //
// ./src/DefaultConfig/apis.js